module.exports = __webpack_public_path__ + "static/about_services03-1e889e293bba17524f42a49abfe5dc92.png";